export const formatMoney = (value) => {
	if (!value) {
	  return '0'
	}
	const val = Number(value).toFixed(0).replace('.', ',')
	return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }